// extracted by mini-css-extract-plugin
var _1 = "MonthDays-moduleMonthDays__i0auT";
var _2 = "MonthDays-moduleitem__gqJIk MonthDay-moduleMonthDay__TWPsN Day-moduleDay__tTwxX";
export { _1 as "MonthDays", _2 as "item" }
